import { Skeleton } from 'antd';
import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "NewCollectionstyle__Container",
  componentId: "sc-3wu8am-0"
})(["", " @media (max-width:", "){", "}@media (max-width:", "){", "}@media (max-width:", "){", "}"], {
  "display": "grid",
  "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
  "gap": "2rem",
  "paddingLeft": "0px",
  "paddingRight": "0px"
}, ({
  theme
}) => theme.breakpoint.xl, {
  "paddingLeft": "1rem",
  "paddingRight": "1rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))"
});
export const Cover = styled(Skeleton.Node).withConfig({
  displayName: "NewCollectionstyle__Cover",
  componentId: "sc-3wu8am-1"
})(["", ""], {
  "height": "100% !important",
  "width": "100% !important",
  "borderRadius": "1rem !important"
});
export const RightContent = styled.div.withConfig({
  displayName: "NewCollectionstyle__RightContent",
  componentId: "sc-3wu8am-2"
})(["", " @media (max-width:", "){", "}"], {
  "display": "grid",
  "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
  "gap": "2rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "display": "flex",
  "width": "100%",
  "gap": "1rem"
});
export const Content = styled.div.withConfig({
  displayName: "NewCollectionstyle__Content",
  componentId: "sc-3wu8am-3"
})(["", " @media (max-width:", "){", " aspect-ratio:8/7;}@media (max-width:", "){", " aspect-ratio:7/8;}"], {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "space-between",
  "padding": "2.5rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "padding": "1.75rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "padding": "1rem"
});
export const Title = styled.div.withConfig({
  displayName: "NewCollectionstyle__Title",
  componentId: "sc-3wu8am-4"
})(["", ""], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column"
});
export const SkeletonTitle = styled(Skeleton.Button).withConfig({
  displayName: "NewCollectionstyle__SkeletonTitle",
  componentId: "sc-3wu8am-5"
})(["", " @media (max-width:", "){", "}"], {
  "marginBottom": "0.5rem",
  "height": "4rem !important",
  "width": "80% !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "height": "2.25rem !important"
});
export const SkeletonMenuAmount = styled(Skeleton.Button).withConfig({
  displayName: "NewCollectionstyle__SkeletonMenuAmount",
  componentId: "sc-3wu8am-6"
})(["", " @media (max-width:", "){", "}"], {
  "marginBottom": "0.5rem",
  "height": "2rem !important",
  "width": "5rem !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "1.5rem",
  "height": "1.5rem !important"
});
export const RecipeThumbSWrapper = styled.div.withConfig({
  displayName: "NewCollectionstyle__RecipeThumbSWrapper",
  componentId: "sc-3wu8am-7"
})(["", " @media (max-width:", "){grid-template-columns:80px 80px 80px 80px;}@media (max-width:", "){grid-template-columns:64px 64px 64px 64px;", "}"], {
  "display": "grid",
  "width": "100%",
  "gridTemplateColumns": "repeat(4, minmax(0, 1fr))",
  "gap": "1rem"
}, ({
  theme
}) => theme.breakpoint.lg, ({
  theme
}) => theme.breakpoint.md, {
  "gap": "0.5rem !important"
});
export const RecipeThumbS = styled(Skeleton.Image).withConfig({
  displayName: "NewCollectionstyle__RecipeThumbS",
  componentId: "sc-3wu8am-8"
})(["", " svg{", "}"], {
  "aspectRatio": "1 / 1 !important",
  "height": "100% !important",
  "width": "100% !important",
  "borderRadius": "0.75rem !important"
}, {
  "display": "none"
});
export const RecipeThumbWrapper = styled.div.withConfig({
  displayName: "NewCollectionstyle__RecipeThumbWrapper",
  componentId: "sc-3wu8am-9"
})(["", ""], {
  "width": "340px"
});